import { axiosInstance } from "../axios";

export const loginIsuper = async ({ username, password }) => {
    return axiosInstance
        .post(`/isuper/login/`, {
            username,
            password
        })
};